
import React from "react";
import { useNavigate } from "react-router-dom";

export default function SchoolItem(props) {
    const navigate = useNavigate();

    const navigateHandler = () => {
        if (props.category === "shkolla") {
            navigate(`/shkollat-e-mesme-profesionale/${props.id}`);
        } else if (props.category === "qendra") {
            navigate(`/formation-centers/${props.id}`);
        } else if (props.category === "profile") {
            navigate('');
        } else {
            navigate(`/drejtime/${props.id}`);
        }
    };


    const baseStyle = props.variant === "filterPage"
        ? "bg-white text-black my-2 p-3 font-bold cursor-pointer hover:bg-red-50 rounded-[10px]" // style for 3rd component
        : "bg-[#db3222] text-white my-2 p-3 font-bold cursor-pointer"; // default style for other pages

    return (
        <div
            className={baseStyle}
            onClick={navigateHandler}
            category={props.category}
        >
            {props.title}
            {!!props.qyteti && `, ${props.qyteti}`}
        </div>
    );
}
